import { HttpClient, HttpEvent, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";
import { GetRntSancionesPersonasRequest } from './asignar-sanciones-persona.interface';
import { Observable } from 'rxjs/internal/Observable';
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { retry } from "rxjs/operators";

@Injectable({
    providedIn: "root",
  })
export class AsignarSancionesPersonasService{
    private API_URL;
  
    constructor(
      private http: HttpClient,
      private enviromentGlobalService: EnviromentGlobalService
    ) {
      this.API_URL = this.enviromentGlobalService.apiUrl;
    }

    getRntAsociado(request: GetRntSancionesPersonasRequest,page_number: number): Observable<ResponseServiceModel>{
        return this.http
        .post<ResponseServiceModel>(
          `${this.API_URL}/SancionesPersonas/GetListadoRnt?pageSize=12&pageNumber=${page_number}`,
          request
        )
        .pipe(retry(2));
    }
    getById(id: number): Observable<ResponseServiceModel>{
      return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/SancionesPersonas/GetSancionPorId/${id}`,
      )
      .pipe(retry(2));
    }
    crearSancion(entry: any,file: File):Observable<any>{
        const input = new FormData();
        input.append("persona_id", entry.persona_id);
        input.append("numero_resolucion", entry.numero_resolucion);
        if(entry.valor_uvt){
          input.append("valor_uvt", entry.valor_uvt);
        }
        input.append("fecha_eje_acto_admin", entry.fecha_eje_acto_admin);
        input.append("fecha_exp_acto_admin", entry.fecha_exp_acto_admin);
        input.append("texto_certificado", entry.texto_certificado);
        input.append("motivo_sancion", entry.motivo_sancion);
        input.append("fecha_inicial", entry.fecha_inicial);
        if(entry.fecha_final){
          input.append("fecha_final", entry.fecha_final);
        }
        input.append("sancion_estado_id", entry.sancion_estado_id);
        input.append("decreto_1836", entry.decreto_1836);
        input.append("listado_rnt_string",entry.listado_rnt);
        if(file){
          input.append("nombre_archivo", file.name);
          input.append("archivo", file, file.name);
        }
        const uploadReq = new HttpRequest(
        "POST",
        `${this.API_URL}/SancionesPersonas/Crear`,
        input
        );
        return this.http.request<any>(uploadReq).pipe(retry(2));
    }
    editarSancion(entry: any,file: File):Observable<any>{
      const formData = new FormData();
      formData.append("persona_id", entry.persona_id);
      formData.append("numero_resolucion", entry.numero_resolucion);
      if(entry.valor_uvt){
        formData.append("valor_uvt", entry.valor_uvt);
      }
      formData.append("fecha_eje_acto_admin", entry.fecha_eje_acto_admin);
      formData.append("fecha_exp_acto_admin", entry.fecha_exp_acto_admin);
      formData.append("texto_certificado", entry.texto_certificado);
      formData.append("motivo_sancion", entry.motivo_sancion);
      formData.append("fecha_inicial", entry.fecha_inicial);
      if(entry.fecha_final){
        formData.append("fecha_final", entry.fecha_final);
      }
      formData.append("sancion_estado_id", entry.sancion_estado_id);
      formData.append("decreto_1836", entry.decreto_1836);
      formData.append("listado_rnt_string",entry.listado_rnt);
      formData.append("nombre_archivo", file.name);
      if(file && file.size > 0){
        formData.append("archivo", file, file.name);
      }
      const uploadReq = new HttpRequest(
        "POST",
        `${this.API_URL}/SancionesPersonas/Actualizar/${entry.sancion_id}`,
        formData,
      );
      return this.http.request<any>(uploadReq).pipe(retry(2));
    }
}